import { House } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HomeIcon = createLucideIcon(House);
